module.exports = __webpack_public_path__ + "static/media/na.05f127b0.svg";